// extracted by mini-css-extract-plugin
export default {"main":"ec032d4b6c","tit":"d6a46c4811","maintitle":"_4b48e567ab","ylw":"_1462dd9586","white":"_74c6dc1664","mv_title":"bde0c91508","mv_nc":"d532eef085","mv_in":"cf5a4432bc"};